import { render, staticRenderFns } from "./tr-TR.vue?vue&type=template&id=35a1ecc8&"
import script from "./tr-TR.vue?vue&type=script&lang=js&"
export * from "./tr-TR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a1ecc8')) {
      api.createRecord('35a1ecc8', component.options)
    } else {
      api.reload('35a1ecc8', component.options)
    }
    module.hot.accept("./tr-TR.vue?vue&type=template&id=35a1ecc8&", function () {
      api.rerender('35a1ecc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/tr-TR.vue"
export default component.exports